import { useEffect, useMemo } from "react"
import { useTranslation } from "react-i18next"

import * as Sentry from "@sentry/browser"
import { loadStripe } from "@stripe/stripe-js/pure"

import { Text, EmptyState, Heading } from "@oysterhr/ui"

import { useAccountAspect } from "@oysterhr/identity/AccountAspectContext"
import useCreatePadCheckoutSession from "./hooks/useCreatePadCheckoutSession"

export const PadFlow = () => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/LandingPage")
  const { accountAspect: companyId } = useAccountAspect()

  const { createPadCheckoutSession } = useCreatePadCheckoutSession()

  const stripePromise = useMemo(() => loadStripe(window.gon.stripeOysterHrCaLtdPublishableKey), [])

  useEffect(() => {
    const redirectToCheckout = async () => {
      const response = await createPadCheckoutSession({ variables: { companyId: companyId } })
      const session = response.data?.createPadCheckoutSession.checkoutSession

      const stripe = await stripePromise

      if (session) {
        const result = await stripe?.redirectToCheckout({
          sessionId: session.sessionId,
        })

        if (result?.error?.message) {
          Sentry.captureException(result.error.message)
        }
      }
    }

    redirectToCheckout()
  }, [companyId, stripePromise, createPadCheckoutSession])

  return (
    <div className="p-8">
      <Heading as="h2" className="font-semibold">
        {t("title")}
      </Heading>
      <Text className="mt-4 text-gray-400">{t("subtitle")}</Text>
      <div className="flex justify-center">
        <EmptyState className="w-1/2">
          <EmptyState.Heading>{t("emptyState.title")}</EmptyState.Heading>
          <EmptyState.Content>
            <Text>{t("emptyState.description")}</Text>
          </EmptyState.Content>
          <EmptyState.Actions>
            <EmptyState.ActionButton isLoading>{t("emptyState.button")}</EmptyState.ActionButton>
          </EmptyState.Actions>
        </EmptyState>
      </div>
    </div>
  )
}
